import { render } from "./ReturnPolicy_MiruWonderland.vue?vue&type=template&id=0033d33d"
import script from "./ReturnPolicy_MiruWonderland.vue?vue&type=script&lang=js"
export * from "./ReturnPolicy_MiruWonderland.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__